module.exports = __webpack_public_path__ + "img/组 1106.6e83802a.png";